import { render, staticRenderFns } from "./EditBrochure.vue?vue&type=template&id=699d9f56&scoped=true&lang=pug&"
import script from "./EditBrochure.vue?vue&type=script&lang=ts&"
export * from "./EditBrochure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699d9f56",
  null
  
)

export default component.exports